import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Ng2SmartTableModule } from 'ng2-smart-table';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ReactiveFormsModule } from '@angular/forms';
import { CKEditorModule } from 'ngx-ckeditor';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';


import { AlumniFeedbackRoutingModule } from './alumni-feedback-routing.module';
import { AlumniFeedbackListComponent } from './alumni-feedback-list/alumni-feedback-list.component';
import { AlumniFeedbackViewComponent } from './alumni-feedback-view/alumni-feedback-view.component';

@NgModule({
  declarations: [AlumniFeedbackListComponent, AlumniFeedbackViewComponent],
  imports: [
    CommonModule,
    AlumniFeedbackRoutingModule,
    NgbModule,
    ReactiveFormsModule,
    CKEditorModule,
    NgxDatatableModule,
    Ng2SmartTableModule
  ]
})
export class AlumniFeedbackModule { }
